var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col" },
    [
      _c("p", { staticClass: "step-caption ft-bld" }, [
        _vm._v("Configure your tag row"),
      ]),
      _vm._v(" "),
      _c("InputWrapper", {
        attrs: { placeholder: "Row name", "max-chars": 18 },
        model: {
          value: _vm.Global.newRowOverlay.name,
          callback: function ($$v) {
            _vm.$set(_vm.Global.newRowOverlay, "name", $$v)
          },
          expression: "Global.newRowOverlay.name",
        },
      }),
      _vm._v(" "),
      _c("AutoTagsWrapper", {
        staticClass: "row-badges",
        attrs: { placeholder: "Select Tag(s)" },
        on: {
          input: function ($event) {
            _vm.tagsIsDirty = true
          },
        },
        model: {
          value: _vm.Global.newRowOverlay.tags,
          callback: function ($$v) {
            _vm.$set(_vm.Global.newRowOverlay, "tags", $$v)
          },
          expression: "Global.newRowOverlay.tags",
        },
      }),
      _vm._v(" "),
      _c("SelectOptsWrapper", {
        staticClass: "mre-z",
        attrs: { caption: "Sort", opts: ["Most Popular", "Best rated"] },
        model: {
          value: _vm.Global.newRowOverlay.sort,
          callback: function ($$v) {
            _vm.$set(_vm.Global.newRowOverlay, "sort", $$v)
          },
          expression: "Global.newRowOverlay.sort",
        },
      }),
      _vm._v(" "),
      _c("SliderWrapper", {
        attrs: {
          caption: "Number of contents in row",
          "range-min": 5,
          "range-max": 45,
        },
        model: {
          value: _vm.Global.newRowOverlay.assetsCount,
          callback: function ($$v) {
            _vm.$set(_vm.Global.newRowOverlay, "assetsCount", $$v)
          },
          expression: "Global.newRowOverlay.assetsCount",
        },
      }),
      _vm._v(" "),
      _c("SelectOptsWrapper", {
        attrs: { caption: "Place this row", opts: _vm.displayAfterList },
        model: {
          value: _vm.displayAfter,
          callback: function ($$v) {
            _vm.displayAfter = $$v
          },
          expression: "displayAfter",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nxt-out" }, [
        _c(
          "div",
          {
            staticClass: "btn bck",
            style: _vm.Global.rowIdToEdit
              ? { opacity: 0, pointerEvents: "none" }
              : null,
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("prv")
              },
            },
          },
          [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("Validate")]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }